var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import set from "lodash/set";
import get from "lodash/get";
import { BookModel } from "..";
import { normalizeField } from "../../../components/BookingFormPage/field-meta";
import { SWITCHABLE_FIELD } from "../../../classConstants";
import { deriveFieldMessage, isValidationDisabled } from "../../../components/BookingForm/booking-form.helpers";
import i18next from "i18next";
var FormFieldModel = /** @class */ (function (_super) {
    __extends(FormFieldModel, _super);
    function FormFieldModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormFieldModel.prototype, "fieldType", {
        get: function () {
            return this.get("field_type_name");
        },
        enumerable: false,
        configurable: true
    });
    FormFieldModel.prototype.selectOptions = function () {
        return this.hasMany("extra_column_dropdown_options", "selectOptions");
    };
    FormFieldModel.prototype.getFieldOptions = function () {
        switch (this.fieldType) {
            case "salutation":
                return this.modelManager.getCollection("salutations").getAsSelectOptions({ label: "humanIdentifier" });
            case "country":
                return this.modelManager.getCollection("countries").getAsSelectOptions();
            case "select":
                return this.selectOptions().getAsSelectOptions({ label: "name" });
            default:
        }
    };
    FormFieldModel.prototype.getTableName = function () {
        return this.get("table_name");
    };
    Object.defineProperty(FormFieldModel.prototype, "isExtraColumn", {
        get: function () {
            return this.getTableName() === "extra_columns";
        },
        enumerable: false,
        configurable: true
    });
    FormFieldModel.prototype.getItemName = function () {
        var columnName = (this.isExtraColumn ? this.get("name") : this.get("column_name"));
        return this.fieldType === "email_confirmed" ? columnName.replace("email", "email_confirmed") : columnName;
    };
    FormFieldModel.prototype.isConditionallyRequired = function (form, fieldName) {
        var validationRule = this.get("validation_rule");
        if (!(validationRule === null || validationRule === void 0 ? void 0 : validationRule.trim())) {
            return false;
        }
        var value = get(form, fieldName);
        var nameArr = fieldName.split(".");
        var rules = validationRule.split("|")
            .map(function (rule) { return rule.split(":"); })
            .reduce(function (all, _a) {
            var _b = _a[0], rule = _b === void 0 ? "" : _b, _c = _a[1], values = _c === void 0 ? "" : _c;
            rule = rule === null || rule === void 0 ? void 0 : rule.trim();
            switch (rule) {
                case "required_without":
                    all[rule] = values.split(",").map(function (x) { return x.trim(); }).map(function (name) {
                        nameArr[nameArr.length - 1] = name;
                        return nameArr.join(".");
                    });
                    return all;
                default:
                    return all;
            }
        }, {});
        if (value) {
            return true;
        }
        if (rules.required_without) {
            var getter_1 = get;
            return rules.required_without.some(function (name) { return !getter_1(form, name); });
        }
        return false;
    };
    FormFieldModel.prototype.getField = function (form, validationErrors, _a) {
        var _b, _c, _d, _e;
        var _f = _a === void 0 ? {} : _a, _g = _f.prefix, prefix = _g === void 0 ? "" : _g, _h = _f.index, index = _h === void 0 ? "" : _h, _j = _f.validationPrefix, validationPrefix = _j === void 0 ? prefix : _j;
        var fields = [];
        var itemName = this.getItemName();
        var fieldName = [prefix, itemName].filter(Boolean).join(".");
        var validationFieldName = [validationPrefix, itemName].filter(Boolean).join(".");
        var switchName = "additional_props.switchable." + fieldName;
        var hideBehindSwitch = !!this.get("switchable_show_on_yes");
        var switchInitialValue = get(form, switchName);
        var is_required = this.get("is_required") || hideBehindSwitch || this.isConditionallyRequired(form, fieldName);
        var isCheckbox = this.fieldType === "checkbox";
        var isConfirmEmail = this.fieldType === "email_confirmed";
        var typeofDefaultField = typeof this.get("default_value") === "boolean" ? "boolean" : "string";
        var defaultValue = this.get("default_value");
        var initialValue = get((_b = form === null || form === void 0 ? void 0 : form.getDefaultData) === null || _b === void 0 ? void 0 : _b.call(form, true), fieldName, undefined);
        // let fieldValue = get(form, fieldName);
        // if (defaultValue && !fieldValue) {
        //     fieldValue = defaultValue;
        // }
        if (defaultValue && typeofDefaultField !== "boolean") {
            defaultValue = String(defaultValue);
        }
        if ((form === null || form === void 0 ? void 0 : form.setFormDefaultValues) && defaultValue) {
            form.setFormDefaultPathValue(fieldName, defaultValue);
            if (hideBehindSwitch)
                form.setFormDefaultPathValue(switchName, "true");
        }
        else if (form && defaultValue) {
            set(form, fieldName, defaultValue);
        }
        var fieldValue = isCheckbox ? undefined : get(form, fieldName) || defaultValue;
        var field = normalizeField(__assign(__assign({}, this), { is_required: is_required, title: isConfirmEmail ? i18next.t("bookcart.confirm_email_title") : this.get("title") }), {
            defaultChecked: isCheckbox ? false : undefined,
            options: this.getFieldOptions(), name: fieldName,
            initialValue: fieldValue || defaultValue || undefined,
            // value: fieldValue,
            className: hideBehindSwitch ? SWITCHABLE_FIELD : "",
            disabled: ((_c = form === null || form === void 0 ? void 0 : form.isParticipantDisabled) === null || _c === void 0 ? void 0 : _c.call(form, index)) && (!!initialValue),
            disableValidation: isValidationDisabled(form),
            allowBlank: !defaultValue && undefined,
        });
        if (hideBehindSwitch) {
            fields.push(normalizeField({
                field_type_name: "switch",
                title: this.get("switchable_title"),
                is_required: is_required,
                name: switchName
            }, {
                initialValue: !!initialValue ? "true" : switchInitialValue,
                disabled: ((_d = form === null || form === void 0 ? void 0 : form.isParticipantDisabled) === null || _d === void 0 ? void 0 : _d.call(form, index)) && (!!initialValue),
                disableValidation: isValidationDisabled(form)
            }));
        }
        if (isConfirmEmail) {
            var emailFieldName = fieldName.replace("email_confirmed", "email");
            fields.push(normalizeField(__assign(__assign({}, this), { field_type_name: "email" }), {
                options: this.getFieldOptions(), name: emailFieldName,
                initialValue: get(form, emailFieldName) || defaultValue || undefined,
                className: hideBehindSwitch ? SWITCHABLE_FIELD : "",
                disabled: (_e = form === null || form === void 0 ? void 0 : form.isParticipantDisabled) === null || _e === void 0 ? void 0 : _e.call(form, index),
                disableValidation: isValidationDisabled(form)
            }));
        }
        if (validationErrors) {
            var message = deriveFieldMessage(form, validationErrors, validationFieldName);
            set(field, "error_message", message);
        }
        if (!hideBehindSwitch || switchInitialValue === "true") {
            fields.push(field);
        }
        ;
        return fields;
    };
    return FormFieldModel;
}(BookModel));
export { FormFieldModel };
